import { useMemo, useState } from 'react'
import { SitewideMessageContextControllerProps } from './SitewideMessageContextController.types'
import { SitewideMessageContext } from '../sitewideMessageContext/SitewideMessageContext'
import { POSTHOG_FEATURE_FLAGS, usePostHogFeatureFlag } from '@percent/cause-dashboard/common/hooks'

export const CURRENT_SITEWIDE_MESSAGE_NAME = 'rebrand_notification_message'

export function SitewideMessageContextController({ children }: Readonly<SitewideMessageContextControllerProps>) {
  const sitewideMessage = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.TIL_CAUSES_PORTAL_SITEWIDE_MESSAGE)
  const [shouldShowBanner, setShouldShowBanner] = useState(
    sitewideMessage && !localStorage.getItem(CURRENT_SITEWIDE_MESSAGE_NAME)
  )

  const closeSitewideMessage = () => {
    setShouldShowBanner(false)
    localStorage.setItem(CURRENT_SITEWIDE_MESSAGE_NAME, 'true')
  }

  const value = useMemo(
    () => ({ closeSitewideMessage, shouldShowSitewideMessage: shouldShowBanner }),
    [shouldShowBanner]
  )

  return <SitewideMessageContext.Provider value={value}>{children}</SitewideMessageContext.Provider>
}
